import React from "react";
import MxTooltipContent from "./MxTooltipContent";
import { Grid, SxProps } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
interface MxTooltipBasicProps {
  msg: string;
  children: React.ReactNode;
  sx?: SxProps;
}
const MxTooltipBasic = (props: MxTooltipBasicProps) => {
  return (
    <MxTooltipContent
      sx={{
        width: {
          xs: "auto",
          md: 200
        },
        ...props.sx
      }}
      template={
        <Grid container gap={1}>
          <MxTypography variant="overline" color="grey.600" fontWeight={400}>
            {props.msg}
          </MxTypography>
        </Grid>
      }
    >
      {props.children}
    </MxTooltipContent>
  );
};

export default MxTooltipBasic;
